import { PropTypes } from "prop-types";
import { StyledField } from "../../../styles/StyledField";
import { useState } from "react";
import { Dropzone } from "../../Dropzone";
import { addAttachment } from "../../../api/decision/attachments";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

export default function AddAttachment({ id, setIsAddModalOpen, refetch, newDecision = false, onAddAttachment }) {
	const { axiosPrivate } = useAxiosPrivate();

	const [name, setName] = useState("");
	const [description, setDescription] = useState("");

	const validTypes = [
		"image/jpeg",
		"image/jpg",
		"image/png",
		"image/gif",
		"image/x-icon",
		"application/pdf",
		"application/msword",
		"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	];

	const handleUpload = (file) => {
		// Basic validation
		if (!name.trim()) {
			alert("Please enter a name for the attachment");
			return;
		}
		if (!description.trim()) {
			alert("Please enter a description for the attachment");
			return;
		}

		if (newDecision) {
			// For new decisions, handle locally without API call
			const attachmentData = {
				name: name,
				description: description,
				file: {
					name: file[0].name,
					size: file[0].size,
					type: file[0].type
				},
				tempFile: file[0] // Store the actual file for later upload when decision is saved
			};

			if (onAddAttachment) {
				onAddAttachment(attachmentData);
			}
			setIsAddModalOpen(false);
			return;
		}

		// For existing decisions, use the normal API call
		let formData = new FormData();
		formData.append("name", name);
		formData.append("description", description);
		formData.append("file", file[0]);

		addAttachment(
			axiosPrivate,
			id,
			() => {
				setIsAddModalOpen(false);
				refetch();
			},
			formData
		);
	};

	return (
		<>
			<StyledField mb="12px">
				<label>Name</label>
				<input name="Name" value={name} onChange={(e) => setName(e.target.value)} />
			</StyledField>
			<StyledField mb="12px">
				<label>Description</label>
				<input name="Description" value={description} onChange={(e) => setDescription(e.target.value)} />
			</StyledField>
			<Dropzone cb={handleUpload} validTypes={validTypes} single />
		</>
	);
}

AddAttachment.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	setIsAddModalOpen: PropTypes.func,
	refetch: PropTypes.func,
	newDecision: PropTypes.bool,
	onAddAttachment: PropTypes.func,
};
